const emailPattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const passwordPattern = /^[0-9a-zA-Z]+$/;

export const isEmpty = (value, message = 'This field must not be empty!') => {
    if (value.trim() === '') return message;
};

export const isEmailValid = (value, message = 'Please enter a valid email address!') => {
    if (!emailPattern.test(value)) return message;
};

export const isPasswordValid = (value, message = 'Password Must be alphanumeric e.g @!Afu/12.') => {
    if (passwordPattern.test(value)) return message;
};

export const isValidLength = (value, length) => {
    if (value.trim().length < length) return `This field must be at least ${length} characters long`;
};

export const isPasswordMatch = (password, confirmPassword) => {
    if (password.trim() !== confirmPassword.trim()) return `New Password and confirm password must match`;
};

export const isAmountLessThan = (value, amount) => {
    if (typeof value === 'string') {
        if (value.trim() < amount) return `Amount cannot be less than ${amount}`;
    } else {
        if (value < amount) return `Value cannot be less than ${amount}`;
    }
};
